import { Container, Grid } from "@mui/material";
import { graphql, useStaticQuery } from "gatsby";
import { getImage, StaticImage } from "gatsby-plugin-image";
import { useTranslation } from "react-i18next";
import LinkSection from "../Common/LinkSection";
import { NavItem } from "../Common/NavItem";
import { legalLinks } from "./footer-links";

type FooterProps = {
  navItems: NavItem[];
};

const Footer = ({ navItems }: FooterProps) => {
  const { t } = useTranslation();

  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "footer-background.webp" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
    }
  `);

  const image = getImage(data.file.childImageSharp.gatsbyImageData);

  return (
    <>
      <footer
        className="bg-footer"
        style={{
          backgroundImage: `url(${image!.images.fallback!.src})`,
          backgroundRepeat: "no-repeat",
        }}
      >
        <Container>
          <Grid container className="py-5">
            <Grid item lg={4}>
              <div className="mt-2">
                <h6 className="text-white text-uppercase f-16">LANCHAS LA GAVIOTA</h6>
                <p className="text-white mb-0 ">Fun on board</p>
                <div className="mt-5">
                  <ul className="list-inline footer-social mb-0">
                    <li className="list-inline-item">
                      <a
                        aria-label="social link"
                        target="_blank"
                        href="https://www.facebook.com/Lanchas-la-Gaviota-103587648919396"
                        className="rounded"
                        rel="noreferrer"
                      >
                        <StaticImage width={24} src="../../assets/images/socials/facebook.png" alt="facebook" />
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        aria-label="social link"
                        target="_blank"
                        href="https://www.instagram.com/lanchaslagaviota"
                        className="rounded"
                        rel="noreferrer"
                      >
                        <StaticImage width={24} src="../../assets/images/socials/instagram.png" alt="facebook" />
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        aria-label="social link"
                        target="_blank"
                        href="https://www.pinterest.es/lagaviotaexcursions"
                        className="rounded"
                        rel="noreferrer"
                      >
                        <StaticImage width={24} src="../../assets/images/socials/pinterest.png" alt="facebook" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </Grid>
            <Grid item lg={4}>
              <div className="mt-2 pl-0 pl-lg-5">
                <LinkSection
                  title="Menu"
                  links={navItems.map((x) => {
                    return {
                      link: x.type === "home" ? `/#${x.idnm}` : x.href!,
                      title: t(x.navheading),
                      isExternal: x.type === "external",
                    };
                  })}
                />
              </div>
            </Grid>
            <Grid item lg={4}>
              <div className="mt-2">
                <LinkSection
                  title={t("legal-section.title")}
                  links={legalLinks.map((x) => {
                    return {
                      link: x.link,
                      title: t(x.title),
                      isExternal: false,
                    };
                  })}
                />
              </div>
            </Grid>
          </Grid>
        </Container>
        <div className="footer-alt pt-3 pb-3">
          <Container>
            <div className="text-center">
              <p className="text-white mb-0">© {new Date().getFullYear()} Lanchas La Gaviota</p>
            </div>
          </Container>
        </div>
      </footer>
    </>
  );
};

export default Footer;
